module.exports = __webpack_public_path__ + "img/isologo.02f6f339.svg";